import { getBackVersion } from '../config';
import { PersonSnapshot, CompanySnapshot } from '../models/AutoFill';
import api from './api';

const getPersonInfo = (cpf: string): Promise<PersonSnapshot | null> =>
    api.request<PersonSnapshot | null>({
        method: 'GET',
        action: 'AUTOFILL_REQUEST',
        url: `${getBackVersion()}/autofill/${cpf}`,
        timeout: 60000,
    });

const getCompanyInfo = (cnpj: string): Promise<CompanySnapshot | null> =>
    api.request<CompanySnapshot | null>({
        method: 'GET',
        action: 'AUTOFILL_REQUEST',
        url: `${getBackVersion()}/autofill/${cnpj}`,
        timeout: 60000,
    });

export default { getPersonInfo, getCompanyInfo };
